import {
  type NestedPermissions,
  type ProtectionScope,
  type SpecialRolesPermissions,
  type TicketsScope,
} from "@/_store/roles.module";
import { SubscriptionAddon, SubscriptionModule } from "@/constants/workplaces";
import { socAddonsEnabled } from "@/_helpers/subscription";
import { isAddonDisabled, isModuleDisabled } from "@/_helpers/subscription";
import {
  MspRolePermissionScopes,
  ProtectionScopeModules,
  type RolePermissionAccessMode,
  RolePermissionsScope,
} from "@/constants/roles";
import { isPlainObject } from "lodash";

export function useRolesPermissions(scopeName: RolePermissionsScope | MspRolePermissionScopes) {
  const isNestedPermission = (
    permissionValue: NestedPermissions | RolePermissionAccessMode | SpecialRolesPermissions
  ): permissionValue is NestedPermissions => {
    return isSpecialPermission(permissionValue) ? false : isPlainObject(permissionValue);
  };

  const isSpecialPermission = (
    permissionValue: NestedPermissions | RolePermissionAccessMode | SpecialRolesPermissions
  ): permissionValue is SpecialRolesPermissions => {
    return (
      isPlainObject(permissionValue) &&
      Object.values(permissionValue).every((val) => typeof val === "boolean")
    );
  };

  const showPermission = (pName: string | number): boolean => {
    if (
      [
        RolePermissionsScope.WORKSPACE_MANAGEMENT,
        RolePermissionsScope.VIEWS,
        MspRolePermissionScopes.MSP_PORTAL_SCOPE,
      ].includes(scopeName)
    ) {
      return true;
    }
    const permissionName = pName as keyof ProtectionScope | keyof TicketsScope;
    if (permissionName === ProtectionScopeModules.MANAGED_SOC) return socAddonsEnabled();
    if (
      [
        SubscriptionAddon.INBOUND_GATEWAY,
        SubscriptionAddon.WIFI_PHISHING,
        SubscriptionAddon.SECURED_MESSAGES,
      ].includes(permissionName as SubscriptionAddon)
    ) {
      return !isAddonDisabled(permissionName as SubscriptionAddon);
    }

    return !isModuleDisabled(permissionName as SubscriptionModule);
  };
  return {
    isNestedPermission,
    showPermission,
    isSpecialPermission,
  };
}
